module.exports = __webpack_public_path__ + "img/serveCon.e1855713.png";